import clsx from 'clsx';
import { createElement } from 'react';
import unescape from 'lodash/unescape';

import { Content } from '@/lib';
import styles from './List.module.scss';
import { Row } from '../../Row';

type ListProps = Content.List & { root?: boolean };

export function List({ style, items, fluid, root = true }: Content.WithFluid<Content.List & ListProps>) {
  const wrapper = style === Content.ListStyle.ordered ? 'ol' : 'ul';
  const content = createElement(
    wrapper,
    {
      className: clsx(styles.list, fluid && styles.fluid, root && styles.rootList, 'text'),
    },
    <>
      {items.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index.toString()}>
          <div dangerouslySetInnerHTML={{ __html: unescape(item.content) }} />
          {!!item.items?.length && <List style={style} items={item.items} root={false} />}
        </li>
      ))}
    </>
  );
  if (root) {
    return <Row>{content}</Row>;
  }
  return content;
}
